var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('span',[_c('b-icon',{attrs:{"icon":_vm.icon,"variant":_vm.iconVariant}}),_vm._v(" "+_vm._s(_vm.getStatusLabel())+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }